/** HQ milestone rewards and the account-power tuning constant (R19, D39). */
export const HQ_MILESTONES = [
  { level: 5, titleId: "pioneer", title: { de: "Pionier:in", en: "Pioneer" } },
  { level: 10, titleId: "builder", title: { de: "Baumeister:in", en: "Builder" } },
  { level: 15, titleId: "pathfinder", title: { de: "Wegbereiter:in", en: "Pathfinder" } },
  { level: 20, titleId: "architect", title: { de: "Architekt:in", en: "Architect" } },
  { level: 25, titleId: "guardian", title: { de: "Hüter:in der Kolonie", en: "Colony Guardian" } },
  { level: 30, titleId: "founder", title: { de: "Gründer:in", en: "Founder" } },
] as const;
export const HQ_SKIN_FRAGMENT = "itm.base_skin_fragment";
export const HQ_SKIN_FRAGMENT_COST = HQ_MILESTONES.length;
export const RESEARCH_LEVEL_POWER = 25;
